import script from "./Call-WxMiniProgram.vue?vue&type=script&setup=true&lang=js"
export * from "./Call-WxMiniProgram.vue?vue&type=script&setup=true&lang=js"

import "./Call-WxMiniProgram.vue?vue&type=style&index=0&id=5570ed86&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5570ed86"]])

export default __exports__